const iframes = document.querySelectorAll('.iframe-component')

iframes.forEach(iframeContainer => {
    var button = iframeContainer.querySelector('.update-cookies');
    button.addEventListener('click', function () {
        Cookiebot.show();
    });
})

